/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class LiveScheduleListsApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Get the list of live schedules
     */
    public all(__unused?: any): Observable<PagedArray<models.ApiLiveScheduleList>> {
        const path = '/content/live/schedules';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiLiveScheduleList>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
